import { useEffect, useState } from 'react';
import config from "../../config";

const useFetchTerms = (date, isAdmin) => {
  const [terms, setTerms] = useState([]);
  const [refreshTerms, setRefreshTerms] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchDate = date.toISOString();

    const apiUrl = `${config.apiEndpoint}/api/Terms/bydate/${fetchDate}`;
    console.log(apiUrl);
    const token = localStorage.getItem("token");

    setTerms([]);
    setIsLoading(true);

    fetch(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        console.log("API response status:", response);
        return response.json();
      })
      .then((data) => {
        if (data.status === 404) {
          setTerms(null);
        } else {
          console.log("Fetched terms data:", data);
          setTerms(data);
        }
        setRefreshTerms(false); // Reset the refresh state
      })
      .catch((error) => {
        console.log("Error fetching terms:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [date, isAdmin, refreshTerms]); // Add refreshTerms dependency

  return { terms, refresh: () => setRefreshTerms(true), isLoading }; // Return refresh function
};

export default useFetchTerms;
